import React from 'react';
import Contact from "../Components/Contact/Contact";
import "../Assests/Styles/style.css";

export default function Contactus() {
    return (
        <>
            <div className={'contact-wrapper'}>
                <p>
                    Experience the joy of a spotless office & home space and reclaim your precious time.
                    <br />
                    Choose our cleaning services for a sparkling, stress-free life!
                </p>
            </div>
            <Contact />
        </>
    )
}